import Axios from "axios";

import { getAccessToken, isTokenExpiringSoon, refreshAccessToken, removeAccessToken } from "./auth";

import { env } from "@/config/env";

import type { InternalAxiosRequestConfig } from "axios";

let refreshPromise: Promise<void> | null = null;

async function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = "application/json";

    // Proactively refresh the token before it expires so the outgoing request
    // already carries a valid bearer token.
    if (isTokenExpiringSoon() && getAccessToken()) {
      if (!refreshPromise) {
        refreshPromise = refreshAccessToken().finally(() => {
          refreshPromise = null;
        });
      }
      try {
        await refreshPromise;
      } catch {
        // refreshAccessToken already called removeAccessToken(); the request
        // will proceed without a token and receive a 401 which the response
        // interceptor handles.
      }
    }

    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token.access_token}`;
    }
  }

  return config;
}

export const api = Axios.create({
  baseURL: env.API_URL,
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;

    if (error.response?.status === 401) {
      removeAccessToken();
    }

    return Promise.reject({ ...error, message });
  }
);
